var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-light flex-row ai-center" },
    [
      _vm.isBlockedOrDeleted(_vm.person)
        ? [
            _c(
              "div",
              { staticClass: "person-light-disabled__container fs-2 flex-row" },
              [
                _c("CompassIcon", {
                  staticClass: "mr-1 person-light-disabled__icon",
                  attrs: {
                    type: _vm.blockedOrDeletedType,
                    size: "extra-small",
                    icon: "lock-fill"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "gray-80 person-light-disabled__label",
                    class: {
                      strike: _vm.isDeleted(_vm.person),
                      red: _vm.isDeleted(_vm.person)
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getName) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "gray-60 ml-2" }, [
                  _vm._v("(" + _vm._s(_vm.blockedOrDeletedLabel) + ")")
                ])
              ],
              1
            )
          ]
        : [
            _c(
              "CompassAvatarName",
              {
                staticClass: "person-light-avatar__container",
                attrs: { lastname: _vm.getName, size: "extra-small" },
                on: {
                  click: function($event) {
                    return _vm.getUrlPerson()
                  }
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: _vm.getInitials,
                    photo: _vm.getPhoto,
                    colorType: _vm.avatarColor(_vm.getName)
                  }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }